module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tara Wyatt\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Tara Wyatt")]), _vm._v(" has been making up love stories ever since she fell head over heels for the Backstreet Boys almost twenty years ago. Winner of the Unpublished Winter Rose Award, Linda Howard Award of Excellence and the Heart of the West Award, Tara lives in Hamilton, Ontario with the cutest dog in the world and a husband that makes all of her heroes look like chumps.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6LaFDF/tc-custom/9781455590261.jpg?1736856352580",
      "alt": "This image is the cover for the book Necessary Risk, Bodyguard"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Necessary Risk, Bodyguard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("When a former child star is threatened, she finds a professional bodyguard with a decidedly person touch in this “fun and sexy read\" (Smexy Books).")]), _c('br'), _c('br'), _vm._v("Sierra Blake is making a stunning Hollywood comeback—and attracting a scary amount of attention. When her home is vandalized and her safety threatened, it's time to hire protection. But her indecently sexy new bodyguard is giving Sierra some dangerous cravings . . ."), _c('br'), _c('br'), _vm._v("Sean Owens doesn't scare easily. But now he's afraid of losing his heart to his new client. Even so, Sean won't let his feelings for the smart and gorgeous Sierra get in the way of doing his job. Because as the attacks against her escalate, crossing the line between business and pleasure could get them both killed.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grand Central Publishing\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0